var projects = {
    init: function () {
        $('ul.ddInstallations a').on('click', function (e) {
            e.preventDefault();
            $('#hInstallation').val($(this).html());
            $('#hPage').val('1');
            projects.loadPage();
        });
        $('ul.ddMaterial a').on('click', function (e) {
            e.preventDefault();
            $('#hMaterial').val($(this).html());
            $('#hPage').val('1');
            projects.loadPage();
        });
        $('ul.ddCountry a').on('click', function (e) {
            e.preventDefault();
            $('#hCountry').val($(this).html());
            $('#hPage').val('1');
            projects.loadPage();
        });

        $('a.btn__filters-applied').on('click', function (e) {
            e.preventDefault();
            switch ($(this).data('type')) {
                case 'installation':
                    $('#hInstallation').val('');
                    break;

                case 'material':
                    $('#hMaterial').val('');
                    break;

                case 'country':
                    $('#hCountry').val('');
                    break;

                default:
                    break;
            }
            projects.loadPage();
        });
    },
    loadPage: function () {
        var page = encodeURIComponent($('#hPage').val());
        var material = encodeURIComponent($('#hMaterial').val());
        var country = encodeURIComponent($('#hCountry').val());
        var installation = encodeURIComponent($('#hInstallation').val());
        // set page
        var url = './?page=' + page;
        // set others data
        if (material != "") { url += '&material=' + material; }
        if (country != "") { url += '&country=' + country; }
        if (installation != "") { url += '&installation=' + installation; }

        // redirect
        url += '#projects';
        location.href = url;
    }
};

$(function () {
    projects.init();
});